
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import MolhamModalOffcanvas from "components/MolhamModalOffCanvas";
import MolhamButton from "components/ReuseableCompos/MolhamButton";
import useMobile from "customHooks/useMobile";
import useTranslation from "next-translate/useTranslation";
import React, { useEffect, useMemo, useState } from "react";
import { FaCalculator } from "react-icons/fa";
import { resetCheckoutStore, useCheckoutStore, } from "../../../components/ReuseableCompos/SharedDonatePages/DonateModal/CheckoutState";
import CalculatedZakatStep from "../../../components/ReuseableCompos/SharedDonatePages/DonateModal/Steps/CalculatedZakat/CalculatedZakatStep";
import ZakatCalculatorAssetModal from "../../../components/Zakat/ZakatCalculatorAssetModal";
import ZakatItemCard from "../../../components/Zakat/ZakatItemCard";
import { usePreferenceContext } from "../../../context/PreferencesContext";
import useModal from "../../../customHooks/useModal";
import useUtilities from "../../../customHooks/useUtilities";
import ZakatCalculatorLayout from "../../../layout/ZakatCalculatorLayout";
const getNumberFromString = (str: string) => {
    return Number(str.replace(/[^0-9\.]+/g, ""));
};
const ZakatCalculator = () => {
    const { t } = useTranslation("common");
    const { curr } = usePreferenceContext();
    const { showModal, handleCloseModal, handleShowModal } = useModal();
    const { data: utilities } = useUtilities();
    const [goldPricePerKarat, setGoldPricePerKarat] = useState<{
        [key: number]: number;
    }>(null);
    const [silverPrice, setSilverPrice] = useState<number>(null);
    const pricedTypesConsts = useMemo(() => {
        if (!utilities || !curr?.code)
            return typesConsts;
        const newTypesConsts = { ...typesConsts };
        newTypesConsts.gold.karats = Object.keys(utilities.gold_price).map((karat) => getNumberFromString(karat));
        return newTypesConsts;
    }, [utilities, curr?.code]);
    useEffect(() => {
        if (utilities && curr?.code) {
            const goldPrices = pricedTypesConsts.gold.karats.reduce((acc, current) => {
                acc[current] = utilities.gold_price[`${current}_carat`][curr.code];
                return acc;
            }, {} as {
                [key: number]: number;
            });
            setGoldPricePerKarat(goldPrices);
            setSilverPrice(Number(utilities.silver_price[curr.code]));
        }
    }, [utilities, curr?.code, pricedTypesConsts]);
    const [items, setItems] = useState<typesConstsType[]>([]);
    const matches = useMobile("md");
    const onDeleteCard = (index: number) => {
        const newItems = [...items];
        newItems.splice(index, 1);
        setItems(newItems);
    };
    const [isEdit, setIsEdit] = useState(false);
    const [editCardInfo, setEditCardInfo] = useState({});
    const [editCardIndex, setEditCardIndex] = useState(null);
    const onEditCard = (index) => {
        setIsEdit(true);
        setEditCardInfo(items[index]);
        setEditCardIndex(index);
        handleShowModal();
    };
    const onClose = () => {
        setIsEdit(false);
        setEditCardInfo({});
        setEditCardIndex(null);
        handleCloseModal();
    };
    const setData = (data) => {
        if (data.type === "gold") {
            const newGoldPricePerKarat = { ...goldPricePerKarat };
            newGoldPricePerKarat[data.karat] = data.price;
            setGoldPricePerKarat(newGoldPricePerKarat);
        }
        else if (data.type === "silver") {
            setSilverPrice(data.price);
        }
        if (isEdit) {
            const newItems = [...items];
            newItems[editCardIndex] = data;
            setItems(newItems);
            setIsEdit(false);
            setEditCardInfo({});
            setEditCardIndex(null);
            return;
        }
        else {
            setItems([...items, data]);
        }
    };
    const [setModalVisible, setZakatItems, addStepToHistory] = useCheckoutStore((state) => [
        state.setModalVisible,
        state.setZakatItems,
        state.addStepToHistory,
    ]);
    const handleShowCalculateModal = () => {
        resetCheckoutStore();
        setZakatItems(items);
        addStepToHistory(CalculatedZakatStep.name);
        setModalVisible(true);
    };
    return (
    //SEO in layout
    <div className="d-flex justify-content-center align-items-center mt-4">
      <MolhamModalOffcanvas show={showModal} onHide={onClose} header={{ label: "add_new_asset" }}>
        <ZakatCalculatorAssetModal isEdit={isEdit} editCardInfo={editCardInfo} onClose={onClose} goldPriceFromProps={goldPricePerKarat} silverPriceFromProps={silverPrice} curr={curr} returnData={(data) => {
            setData(data);
        }} typesConsts={typesConsts}/>
      </MolhamModalOffcanvas>

      {/* <CalculateModal
          onClose={handleCloseCalculateModal}
          showModal={showCalculateModal}
          items={items}
        /> */}

      <div className="px-2 w-100 d-flex flex-column">
        {items.length === 0 && (<div className="w-100 d-flex flex-column align-items-center justify-content-center">
            <i className={`text-primary`} style={{ fontSize: 100 }}>
              {React.createElement(FaCalculator)}
            </i>
            <h4 className="text-center">{t("zakat_calculator")}</h4>
            <h5 className="text-center text-muted fs-6
            
            ">
              {t("zakat_description")}
            </h5>
          </div>)}
        <ul className="nav nav-tabs mb-0 media-tabs row" role="tablist">
          {items.map((item, index) => {
            return (<ZakatItemCard item={item} index={index} key={index} typesConsts={typesConsts} curr={curr} onDelete={onDeleteCard} onEdit={onEditCard}/>);
        })}
        </ul>
        <div className="px-4 mt-3 d-flex flex-column">
          <MolhamButton id="zakat-add-asset-btn" startIcon="fe-plus" label={t(`add_new_asset`)} className={`mt-2 ${!matches ? " w-50 align-self-center" : " w-100"}`} onClick={handleShowModal}/>

          {items.length !== 0 && (<MolhamButton id="zakat-open-calculate-btn" endIcon="fe-arrow-right" label={t(`calculate_zakat_now`)} className={`mt-2 ${!matches ? " w-50 align-self-center" : " w-100"}`} onClick={handleShowCalculateModal}/>)}
        </div>
      </div>
    </div>);
};
export default ZakatCalculator;
ZakatCalculator.Layout = ZakatCalculatorLayout;
type typesConstsType = {
    [key: string]: {
        title: string;
        amount_label: string;
        price_label: string;
        total_label: string;
        karats?: number[];
        hasWeight?: boolean;
        append?: string;
    };
};
const typesConsts: typesConstsType = {
    money: {
        title: "money_asset",
        amount_label: "money_amount_label",
        total_label: "money_total_label",
        price_label: "money_amount_label",
        append: "currency"
    },
    gold: {
        title: "gold_asset",
        amount_label: "gold_amount_label",
        price_label: "gold_price_label",
        total_label: "gold_total_label",
        karats: [24, 22, 21, 18, 14, 10],
        hasWeight: true,
        append: "gram"
    },
    silver: {
        title: "silver_asset",
        amount_label: "silver_amount_label",
        price_label: "silver_price_label",
        total_label: "silver_total_label",
        hasWeight: true,
        append: "gram"
    },
    stock: {
        price_label: "stock_price_label",
        total_label: "stock_total_label",
        amount_label: "stock_amount_label",
        title: "stock_asset",
        append: "stock_asset"
    }
};

    async function __Next_Translate__getStaticProps__1a13f66c08c__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/zakat/calculator/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || (() => Promise.resolve({})),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a13f66c08c__ as getStaticProps }
  